import React from 'react';
import {
  selectIsFull,
  selectIsDavinci,
  selectIsEmbed,
  selectIsPublic,
} from 'state/environment/environmentSelectors';
import {connect} from 'react-redux';
import {CARD_SETTINGS} from 'app/CardConstants';
import {selectIsCardSettingEnabled} from 'state/cardSetting/cardSettingSelectors';
import FillScale from 'components/FillScale';
import OrientationScale from 'components/OrientationScale';
import styles from './DetailsTable.css?module';
import Table from './Table';
import GenericTable from 'components/Table';
import VirtualizedTable from 'components/VirtualizedTable';

// Required to get back all rows + columns
const ALL_COLUMN_WIDTH = 1024;

class DetailsTable extends React.Component {
  render() {
    const {
      isSummaryEnabled,
      cardId,
      isFull,
      isDavinci,
      isEmbed,
      isPublic,
      ...rest
    } = this.props;
    const CardScale = isFull ? OrientationScale : FillScale;
    const tableComponent =
      isDavinci || isEmbed || isPublic ? GenericTable : VirtualizedTable;

    return (
      <div className={styles.tableVisualization}>
        <CardScale>
          {(width, height, hasComputed) => (
            <Table
              {...rest}
              cardId={cardId}
              width={width}
              phoenixWidth={isDavinci ? width : ALL_COLUMN_WIDTH}
              height={height}
              showSummary={isSummaryEnabled}
              isResizing={!hasComputed}
              pageLayout={isDavinci}
              component={tableComponent}
            />
          )}
        </CardScale>
      </div>
    );
  }
}

export default connect(state => ({
  isDavinci: selectIsDavinci(state),
  isEmbed: selectIsEmbed(state),
  isFull: selectIsFull(state),
  isPublic: selectIsPublic(state),
  isSummaryEnabled: selectIsCardSettingEnabled(state, CARD_SETTINGS.SUMMARY),
}))(DetailsTable);
